export const ENTRY_INTRO_OFFER_WINDOW_MS = 24 * 60 * 60 * 1000;
export const ENTRY_INTRO_FEE_EUR = 89;
export const ENTRY_LIST_FEE_EUR = 139;
/** Client localStorage key for the direct-conversion 24h countdown. Landing and the app are different origins, so each keeps its own value. */
export const DIRECT_CONVERSION_OFFER_ENDS_AT_STORAGE_KEY = 'tipi-signup-direct-conversion-offer-ends-at';
const toCreatedAtMs = (createdAt) => {
    if (createdAt instanceof Date) {
        return createdAt.getTime();
    }
    if (typeof createdAt === 'number') {
        return createdAt;
    }
    if (typeof createdAt === 'string') {
        return new Date(createdAt).getTime();
    }
    if ('toMillis' in createdAt && typeof createdAt.toMillis === 'function') {
        return createdAt.toMillis();
    }
    if ('toDate' in createdAt && typeof createdAt.toDate === 'function') {
        return createdAt.toDate().getTime();
    }
    throw new Error('Lead createdAt is not a valid timestamp');
};
export const getEntryIntroOfferEligibility = (lead, now = new Date()) => {
    const createdAtMs = toCreatedAtMs(lead.createdAt);
    const offerEndsAt = new Date(createdAtMs + ENTRY_INTRO_OFFER_WINDOW_MS);
    return {
        eligible: now.getTime() < offerEndsAt.getTime(),
        offerEndsAt,
    };
};
//# sourceMappingURL=entryIntroOffer.js.map